import { createStyles } from '@mantine/core';

export const useStyles = createStyles( () => ( {
	title: {
		whiteSpace: 'pre-wrap',
		textAlign: 'center',
		marginBottom: '1.5rem',
	},
} ) );
